import {
    Scene,
    PerspectiveCamera,
    WebGLRenderer,
    AudioListener,
    PositionalAudio,
    AudioLoader
  } from 'three';
  
  class SoundShader {
   async setupSpatialAudio(blob, options = {}) {
    const {
      position = { x: 0, y: 0, z: 0 },
      refDistance = 20,
      rolloffFactor = 1,
      dryLevel = 0.7,
      wetLevel = 0.3,
      coneInnerAngle = 360,
      coneOuterAngle = 360,
      coneOuterGain = 0,
      distanceModel = 'inverse',
      maxDistance = 10000,
      playbackRate = 1
    } = options;
  
    const scene = new Scene();
    const camera = new PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    const renderer = new WebGLRenderer();
    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);
  
    const listener = new AudioListener();
    camera.add(listener);
    const sound = new PositionalAudio(listener);
  
    const audioContext = listener.context;
    const convolver = audioContext.createConvolver();
    const dryGain = audioContext.createGain();
    const wetGain = audioContext.createGain();
  
    fetch('resources/05x15y.wav')
      .then(response => response.arrayBuffer())
      .then(buffer => audioContext.decodeAudioData(buffer))
      .then(decodedData => {
        convolver.buffer = decodedData;
      });
  
    //const audioLoader = new AudioLoader();
    const arrayBuffer = await blob.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    //audioLoader.load(soundUrl, (buffer) => {
      sound.setBuffer(audioBuffer);
      sound.setRefDistance(refDistance);
      sound.setRolloffFactor(rolloffFactor);
      sound.setDistanceModel(distanceModel);
      sound.setMaxDistance(maxDistance);
      sound.setPlaybackRate(playbackRate);
      sound.setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain);
      
      sound.connect(dryGain);
      sound.connect(wetGain);
      wetGain.connect(convolver);
      convolver.connect(audioContext.destination);
      dryGain.connect(audioContext.destination);
      
      dryGain.gain.value = dryLevel;
      wetGain.gain.value = wetLevel;
      
      sound.position.set(position.x, position.y, position.z);
      scene.add(sound);
      sound.play();
    //});
  
    camera.position.z = 5;
  
    function animate() {
      requestAnimationFrame(animate);
      renderer.render(scene, camera);
    }
    animate();
  
    // Handle window resize
    window.addEventListener('resize', () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
      renderer.setSize(width, height);
    });
  
    return {
      sound,
      scene,
      camera,
      listener,
      convolver,
      dryGain,
      wetGain,
      updatePosition: (newPos) => {
        sound.position.set(newPos.x, newPos.y, newPos.z);
      },
      updateLevels: (dry, wet) => {
        dryGain.gain.value = dry;
        wetGain.gain.value = wet;
      },
      updatePlaybackRate: (rate) => {
        sound.setPlaybackRate(rate);
      },
      stop: () => {
        sound.stop();
      },
      play: () => {
        sound.play();
      },
      pause: () => {
        sound.pause();
      }
    };
  }
}
  
  /* Usage example
  const audio = setupSpatialAudio('sounds/voice.mp3', {
    position: { x: -2, y: 1, z: 3 },
    refDistance: 15,
    rolloffFactor: 2,
    dryLevel: 0.6,
    wetLevel: 0.4,
    playbackRate: 1.2
  });*/
  
  export default SoundShader;